
import React from 'react';
import ReactDOM from 'react-dom';

import ContactFormContainer from '@components/panel/views/ContactFormContainer';
import { initSideBarToggle } from '@/utils/panel/panel';
import { initShipStationScan } from '@initializers/panel/initialize_ship_station';

const initInfiniteScroll = () => {
  const sentinel = document.getElementById('scroll-sentinel');
  if (!sentinel) return;

  let isLoading = false;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting || isLoading) return;

      const currentPage = parseInt(sentinel.dataset.page, 10);
      const totalPages = parseInt(sentinel.dataset.totalPages, 10);

      if (currentPage >= totalPages) {
        observer.unobserve(sentinel);
        sentinel.remove();
        return;
      }

      isLoading = true;

      const url = new URL(window.location.href);
      url.searchParams.set('page', currentPage + 1);

      fetch(url.toString(), { headers: { Accept: 'application/json' } })
        .then((res) => res.json())
        .then((data) => {
          const tbody = document.getElementById('records-tbody');
          if (tbody) tbody.insertAdjacentHTML('beforeend', data.html);

          // Append any new order_ids_to_skip for the fulfillment warning
          if (data.order_ids_to_skip && data.order_ids_to_skip.length > 0) {
            const msgEl = document.getElementById('order-message');
            if (msgEl) {
              const existing = $(msgEl).data('orderids').toString();
              const newIds = data.order_ids_to_skip.join(',');
              const combined = existing ? `${existing},${newIds}` : newIds;
              $(msgEl).data('orderids', combined);
            }
          }

          sentinel.dataset.page = data.current_page;

          const labelEl = sentinel.querySelector('.scroll-sentinel-label');
          if (data.current_page >= data.total_pages) {
            observer.unobserve(sentinel);
            sentinel.remove();
          } else if (labelEl) {
            labelEl.textContent = 'Loading more records...';
          }
        })
        .catch(() => {
          const labelEl = sentinel.querySelector('.scroll-sentinel-label');
          if (labelEl) labelEl.textContent = 'Failed to load more records. Scroll up and back down to retry.';
        })
        .finally(() => {
          isLoading = false;
        });
    });
  }, { rootMargin: '300px' });

  observer.observe(sentinel);
};

const initializeViews = (view) => {
  $(() => {
    initSideBarToggle(view);
    initShipStationScan();

    const assingNewLocation = function () {
      const params = {};

      $('.view-filter').each((_index, el) => {
        params[el.name] = $(el).val();
      });

      const sortingColumn = $('.apply-sorting.active');
      if (sortingColumn.length > 0) {
        params.sort_column = sortingColumn.data('column');
        params.sort_direction = sortingColumn.data('direction');
      }

      const newLocation = `${window.location.pathname}?${$.param(params)}`;
      window.location.assign(newLocation);
    };

    $('form.view-filter-form').on('submit', (e) => {
      e.preventDefault();

      assingNewLocation();
    });

    $('.sortable-headres').on('click', '.apply-sorting', (e) => {
      e.preventDefault();
      const isActive = $(e.target).hasClass('active');
      $('.apply-sorting').removeClass('active');
      if (!isActive) $(e.target).addClass('active');

      assingNewLocation();
    });

    $('input#keyword').keyup((event) => {
      const keywordEmpty = !event.target.value;
      $('button.reset-keyword').prop('disabled', keywordEmpty);
    }).trigger('keyup');

    $('button.reset-keyword').click((event) => {
      event.preventDefault();

      $('input#keyword').val('');

      $(event.target).closest('form').submit();
    });

    // Use event delegation so dynamically loaded rows also update the button state
    $(document).on('click', 'input.order-checkbox', () => {
      const selectedCheckbox = $('.order-checkbox:checked').length > 0;
      $('#packing-slip-button').attr('disabled', !selectedCheckbox);
    });

    $('#packing-slip-button').click(() => {
      const selectedCheckbox = $('.order-checkbox:checked');
      const selectedOrderIds = [];
      selectedCheckbox.each((_index, el) => {
        selectedOrderIds.push($(el).val());
      });

      const el = $('#order-message');
      el.css('display', 'none');
      const ordersToSkip = $(el).data('orderids').toString().split(',');

      selectedOrderIds.forEach((orderId) => {
        if (ordersToSkip.includes(orderId.toString())) {
          el.css('display', 'block');
        }
      });
    });

    initInfiniteScroll();
  });
};

const initializeContactForm = (data, price) => {
  ReactDOM.render(
    <ContactFormContainer landingPages={data.landing_pages} prices={price.prices}/>,
    document.querySelector('#new-contact-container[data-behavior="react"]'),
  );
};

export {
  initializeViews, initializeContactForm,
};
